import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import {
  PARTNER_TASK_CATEGORY_PRICING,
  PARTNER_TASK_STATUS_SENT,
} from 'common/partnerTaskConstants';

import ButtonDeprecated, {
  BUTTON_THEME_BLUE_GREYCLIFF,
  BUTTON_THEME_GRAY_GREYCLIFF,
} from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';

import useBranch from 'client/hooks/useBranch';

import './SrFlatLinedListingsModal.less';

const SrFlatLinedListingsModal = ({ partner, partnerTasks }) => {
  const modalViewedPath = ['partners', 'flatLinedListingAlertViewedByPartnerId', partner.id];
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const { dispatch, modalViewed } = useBranch({
    modalViewed: modalViewedPath,
  });

  const tasks = partnerTasks.filter((task) => {
    return (
      task.category === PARTNER_TASK_CATEGORY_PRICING &&
      task.keyword === 'flatLined' &&
      task.status === PARTNER_TASK_STATUS_SENT
    );
  });

  useEffect(() => {
    if (partnerTasks.length > 0 && !tasks.length) {
      setModalIsOpen(false);
    }
  }, [partnerTasks, tasks]);

  const _closeModal = () => {
    setModalIsOpen(false);

    dispatch(({ state }) => {
      state.set(modalViewedPath, true);
      state.commit();
    });
  };

  const _viewTable = () => {
    const element = global.document.querySelector('.TaskListSection');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', alignToTop: true });
    }
    _closeModal();
  };

  if (!modalIsOpen || modalViewed || tasks.length === 0) {
    return null;
  }

  return (
    <SrDarkModal>
      <SrModalContent width={700}>
        <div styleName="modalContent">
          <div styleName="icon" />
          <div styleName="titleBox">
            <span styleName="title">
              {pluralize('listing', tasks.length, true)} {tasks.length === 1 ? 'is ' : 'are '}
              flatlined. <br />
              We recommend price reductions.
            </span>
          </div>
          <div styleName="contentBox">
            <span styleName="contentText">
              Listings with zero leads in a week are '
              <span styleName="contentText strong">flat-lined.</span>' Our research shows flatlined
              listings have an extremely low chance of getting leased, until you lower the price.
            </span>
          </div>
          <div styleName="buttonBox">
            <ButtonDeprecated theme={BUTTON_THEME_BLUE_GREYCLIFF} onClick={_viewTable}>
              View Price Recommendations
            </ButtonDeprecated>
            <ButtonDeprecated theme={BUTTON_THEME_GRAY_GREYCLIFF} onClick={_closeModal}>
              I'm working on it...
            </ButtonDeprecated>
          </div>
        </div>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrFlatLinedListingsModal.propTypes = {
  partner: PropTypes.object.isRequired,
  partnerTasks: PropTypes.array.isRequired,
};

SrFlatLinedListingsModal.displayName = 'SrFlatLinedListingsModal';

export default SrFlatLinedListingsModal;
